import Webapi from './webapi'
import auth from '../auth'

const contentType = 'application/json'

const webapi = () =>
    new Webapi()
        .authorization(auth.get())
        .contentType(contentType)
        .accept(contentType)
        .path('locker-consignments')

export const getLockerConsignments = (token) =>
    webapi()
        .path('order')
        .path(token)
        .get()
